import DataStoreFields from 'js/data-store/data-store-fields/data-store-fields';
/*
	
	Goal: Produce a flat array of records to display based on:
		nesting
		filter
		sort 

	Hard parts:
		Display records needs to be live so that new records created get appended.		
		Sorting by manual sort should be live (e.g. if someone else sorts, you get new order)
		Sorting by a field just updates the manual sort order
		Each child level should be sorted within itself(respecting above rules)
		Numbering needs to be consistent and true at the final stage (e.g as displayed)
		Regular add row shifts to manual sort mode and slots new record into bottom
		When filtering is applied, we will include parents that don't fit the filter criteria if any children (or children...) do all the way up to root	
		Disclosure triangles only have "power" over what's shown if they're visible (e.g. they don't impact children if they're too high above the highest level shown)
	
*/


const EXISTNG_RECORD_TYPE = 'existingRecord';
const NEW_RECORD_TYPE = 'newRecord';
const GRID_HEADER_TYPE = 'gridHeader';
const GRID_HELPER_TYPE = 'gridHelper';
const GRID_HEADER_ROW = {
	heightPX: 40,
	key: 'grid-header',
	type: GRID_HEADER_TYPE,
	record: null,
};
const GRID_HELPER_ROW = {
	heightPX: 40,
	key: 'grid-helper',
	type: GRID_HELPER_TYPE,
	record: null,
}

class DisplayableRow{
	constructor({depth, depthFromDisplayedRoot, distanceAboveTerminalDepth}){
		const drSelf = this;
		drSelf.ownNestedItem = null;
		drSelf.depth = depth;
		drSelf.depthFromDisplayedRoot = depthFromDisplayedRoot;
		drSelf.distanceAboveTerminalDepth = distanceAboveTerminalDepth;

		drSelf.includedByFilters = true;
		drSelf.includedByNesting = true;
		drSelf.isVisible = true;
	}
	setOwnNestedItem(nestedItem){
		this.ownNestedItem = nestedItem;
	}
	isIncludedByFilters({sheetView, activeLabels, systemState, ConnectedApps}){
		const drSelf = this;

		const record = drSelf.record;
		
		if(record){			

			const schema = record.dataStore.meta.schema;

			for(let fieldGUID in activeLabels){
				if(activeLabels[fieldGUID]){					
					if(schema.fields[fieldGUID] && activeLabels[fieldGUID] && activeLabels[fieldGUID].filtering && activeLabels[fieldGUID].filtering.activeFilteredValues.length > 0){						
						const fieldType = schema.fields[fieldGUID].field.fieldType;
						
						const groupValue = DataStoreFields.fieldTypes[fieldType].features.picklist.getPicklistKeyFromValue({
							value: record.getFieldValue(fieldGUID),
							dataStore: record.dataStore,
							fieldGUID,
							systemState,
							ConnectedApps,
						});

						if(groupValue !== null && groupValue !== undefined){
							if(Array.isArray(groupValue)){
								let valueWasFound = false;
								for(let valIndex = 0; !valueWasFound && valIndex < groupValue.length; valIndex++){
									valueWasFound = activeLabels[fieldGUID].filtering.activeFilteredValues.indexOf(groupValue[valIndex]) >= 0;
								}
								if(!valueWasFound){
									return false;
								}
							}
							else{
								let foundInFilteredListActive = activeLabels[fieldGUID].filtering.activeFilteredValues.indexOf(groupValue) >= 0;
								if(!foundInFilteredListActive){
									return false;
								}
							}							
						}
						else{
							if(sheetView.isPicklistFilteredByBlankValue(fieldGUID)){
								continue;
							}
							else{
								return false;
							}
						}							
					}
					else{							
						// console.log(`Field ${fieldGUID} is a label but doesnt have filters applied`)
					}
				}
				else{
					// console.log(`Field ${fieldGUID} isn't a label`)
				}						
			}
		}
		return true;
	}		
	setAndReturnFilterAndNestingVisibility(parameters){
		const drSelf = this;

		const {
			sheetView,
			activeLabels,
			systemState,
			ConnectedApps,
		} = parameters;

		drSelf.includedByFilters = drSelf.isIncludedByFilters({
			sheetView,
			activeLabels, 
			systemState, 
			ConnectedApps
		});				

		drSelf.includedByNesting = 
			drSelf.depthFromDisplayedRoot >= 0 && 
			drSelf.distanceAboveTerminalDepth >= 0 &&
			(drSelf.parentsDisclosureTriangleShowsRecordChildren || drSelf.depthFromDisplayedRoot === 0);

		return {
			includedByFilters: drSelf.includedByFilters,
			includedByNesting: drSelf.includedByNesting,
		};
	}
	setUltimateVisibility(isVisible){
		this.isVisible = isVisible;
	}
	appendStats(additionalStats){
		Object.assign(this, additionalStats);
	}
}

class RecordAddRow extends DisplayableRow{
	constructor({parentRecord}, displayableRowDetails){
		super(displayableRowDetails);
		const rarSelf = this;		
		rarSelf.type = NEW_RECORD_TYPE;
		rarSelf.parentRecord = parentRecord;
		rarSelf.record = null;
		Object.assign(rarSelf, displayableRowDetails);
	}
}


class RecordDisplayDetails extends DisplayableRow{
	constructor({record, parentRecord}, displayableRowDetails){
		super(displayableRowDetails);
		const rddSelf = this;
		rddSelf.type = EXISTNG_RECORD_TYPE;
		rddSelf.record = record;
		rddSelf.parentRecord = parentRecord;
		Object.assign(rddSelf, displayableRowDetails);		
	}
}


class NestedItem{
	constructor(ownDisplayDetails, parentItem){

		//RecordDisplayDetails
		this.ownDisplayItem = ownDisplayDetails;
		if(this.ownDisplayItem){
			this.ownDisplayItem.setOwnNestedItem(this);
		}		

		this.parentItem = parentItem;

		//DisplayableRow
		this.childNestedItems = [];

		this.siblingStats;
		this.childCount = 0;
	}
	addChild(childItem){
		this.childNestedItems.push(childItem);
	}
	setAndReturnVisibility(parameters, includedRecordMap){
		const niSelf = this;

		const {
			depth,
			sheetView,
			activeLabels,
			nestingDisclosureArray,
			sheetViewHierarchyRootLevel, 
			sheetViewHierarchyDepth,
			systemState, 
			ConnectedApps,
		} = parameters;

		const arrayOfChildNestedItems = niSelf.childNestedItems;

		let hasVisibleDeepChild = false;
		let hasExistingDeepChildByFilters = false;

		if(arrayOfChildNestedItems.length > 0){					

			for (let childIndex = 0; childIndex < arrayOfChildNestedItems.length; childIndex++) {
				const { deepChildIsVisible, includedByFilters, includedByNesting } = arrayOfChildNestedItems[childIndex].setAndReturnVisibility(parameters, includedRecordMap);
				hasExistingDeepChildByFilters = hasExistingDeepChildByFilters || includedByFilters;
				hasVisibleDeepChild = hasVisibleDeepChild || deepChildIsVisible;
			}
		}		

		if(niSelf.ownDisplayItem){
			const {			
				includedByFilters,
				includedByNesting,
			} = niSelf.ownDisplayItem.setAndReturnFilterAndNestingVisibility({
				sheetView,
				activeLabels,
				systemState,
				ConnectedApps,
			})
			niSelf.ownDisplayItem.setUltimateVisibility((hasExistingDeepChildByFilters || includedByFilters) && includedByNesting);
			if (includedRecordMap && niSelf.ownDisplayItem != undefined && niSelf.ownDisplayItem.record !== null && (includedByFilters || hasVisibleDeepChild)) {
				includedRecordMap[niSelf.ownDisplayItem.record.$internals.metaProperties.meta.guid] = true;
			}

			return {
				includedByFilters,
				includedByNesting,
				deepChildIsVisible: niSelf.ownDisplayItem && niSelf.ownDisplayItem.isVisible,
			};
		}
		return {
			includedByFilters: false,
			includedByNesting: false,
			deepChildIsVisible: false
		};
	}
	recursivelyRemoveInvisibleItems(){
		const niSelf = this;

		const arrayOfChildNestedItems = niSelf.childNestedItems;
		const visibleChildrenArray = [];

		// These are needed to know whether or not to show the nested children triangle
		let hasChildrenThatWouldBeVisibleAccordingToFiltersAndNesting = false;
		let hasChildMeetingFilters = false;

		if(arrayOfChildNestedItems.length > 0){

			for(let childIndex = 0; childIndex < arrayOfChildNestedItems.length; childIndex++){
				if(arrayOfChildNestedItems[childIndex].ownDisplayItem){
					hasChildrenThatWouldBeVisibleAccordingToFiltersAndNesting = hasChildrenThatWouldBeVisibleAccordingToFiltersAndNesting || arrayOfChildNestedItems[childIndex].ownDisplayItem.includedByFilters || arrayOfChildNestedItems[childIndex].ownDisplayItem.includedByNesting;
				 	hasChildMeetingFilters = hasChildMeetingFilters || arrayOfChildNestedItems[childIndex].ownDisplayItem.includedByFilters;
				}
				if(arrayOfChildNestedItems[childIndex].ownDisplayItem.isVisible || arrayOfChildNestedItems[childIndex].ownDisplayItem.depthFromDisplayedRoot < 0){
					visibleChildrenArray.push(arrayOfChildNestedItems[childIndex]);
					arrayOfChildNestedItems[childIndex].recursivelyRemoveInvisibleItems();
				}
			}

			niSelf.childNestedItems = visibleChildrenArray;
		}

		niSelf.hasChildrenThatWouldBeVisibleAccordingToFiltersAndNesting = !!hasChildrenThatWouldBeVisibleAccordingToFiltersAndNesting && !!hasChildMeetingFilters;
	}
	recursivelySortItems({recordToSortIndexMap}){
		const niSelf = this;
		if(niSelf.childNestedItems.length){
			niSelf.childNestedItems = niSelf.childNestedItems.sort(function compareChildNestedItems(childNestedItemA, childNestedItemB){
				let recordA = childNestedItemA.ownDisplayItem.record;
				let recordB = childNestedItemB.ownDisplayItem.record;

				if(recordA && recordB){

					let indexA = recordToSortIndexMap.get(recordA);
					if(indexA === undefined){
						 indexA = Number.MAX_SAFE_INTEGER;
					}

					let indexB = recordToSortIndexMap.get(recordB);
					if(indexB === undefined){
						indexB =  Number.MAX_SAFE_INTEGER;
					}

					// if(indexA === Number.MAX_SAFE_INTEGER || indexA === 0){
					// 	debugger;
					// }
					// if(indexB === Number.MAX_SAFE_INTEGER || indexB === 0){
					// 	debugger;
					// }

					return indexA - indexB;
				}
				else if(recordA){
					return -1;
				}
				else if(recordB){
					return 1;
				}
				else{
					return 0;
				}
			});

			for(let childIndex = 0; childIndex < niSelf.childNestedItems.length; childIndex++){
				niSelf.childNestedItems[childIndex].recursivelySortItems({recordToSortIndexMap})
			}
		}
	}
	addRenderingAnnotations(parameters){

		const niSelf = this;

		const {
			nestingGlobalStats,
			sheetViewHierarchyRootLevel, 
			depth,
		} = parameters;
		
		niSelf.nestingGlobalStats = nestingGlobalStats;		

		const depthFromDisplayedRoot = depth - sheetViewHierarchyRootLevel;		

		//This subtle difference takes into account the fact that we DO want to consider the depth if they are hidden just by the nesting triangle
		if(niSelf.hasChildrenVisibleAccordingToNestingLevelsShown){
			if(depthFromDisplayedRoot > 0 && depthFromDisplayedRoot > nestingGlobalStats.maximumDepth){								
				nestingGlobalStats.maximumDepth = depthFromDisplayedRoot;				
			}
		}

		niSelf.childCount = niSelf.childNestedItems.length;

		if(niSelf.childNestedItems.length){			

			const siblingStats = {
				totalSiblings: niSelf.childNestedItems.length,
			};

			const commonChildrenPassedParameters = Object.assign({}, parameters, {
				depth: depth+1,
			});

			for(let childIndex = 0; childIndex < niSelf.childNestedItems.length; childIndex++){	
				niSelf.childNestedItems[childIndex].siblingStats = siblingStats;
				niSelf.childNestedItems[childIndex].indexAmongChildren = childIndex;
				niSelf.childNestedItems[childIndex].firstInNestedGroup = childIndex === 0;
				niSelf.childNestedItems[childIndex].lastInNestedGroup = childIndex === niSelf.childNestedItems.length - 1;			
				niSelf.childNestedItems[childIndex].addRenderingAnnotations(commonChildrenPassedParameters);
			}			
		}

		// debugger;

	}
	addToFlatArray(flatArray){
		const niSelf = this;
		if(niSelf.ownDisplayItem && niSelf.ownDisplayItem.isVisible){
			flatArray.push(niSelf.getFlatArrayAddableComponent());
		}
		for(let childIndex = 0; childIndex < niSelf.childNestedItems.length; childIndex++){				
			niSelf.childNestedItems[childIndex].addToFlatArray(flatArray);
		}
	}
	getFlatArrayAddableComponent(){
		const niSelf = this;
		niSelf.ownDisplayItem.appendStats({
			childCount: niSelf.childCount,
			hasChildrenVisibleAccordingToNestingLevelsShown: !!niSelf.hasChildrenVisibleAccordingToNestingLevelsShown,
			hasChildrenThatWouldBeVisibleAccordingToFiltersAndNesting: niSelf.hasChildrenThatWouldBeVisibleAccordingToFiltersAndNesting,
			nestingGlobalStats: niSelf.nestingGlobalStats,
			siblingStats: niSelf.siblingStats,
			indexAmongChildren: niSelf.indexAmongChildren,
			firstInNestedGroup: niSelf.firstInNestedGroup,
			lastInNestedGroup: niSelf.lastInNestedGroup,			
			heightPX: 40,
		});
		return niSelf.ownDisplayItem;
	}
}


class GridRecordDisplay{
	constructor(){
		const grdSelf = this;
	}	
	generateLoadingRecordItem(itemNumber){
		return {
			depth: 0,
			depthFromDisplayedRoot: 0,
			distanceAboveTerminalDepth: 0,
			includedByFilters: true,
			includedByNesting: true,
			isVisible: true,
			type: 'loadingRecord',
			key: `loading-record-${itemNumber}`,
			record: null,
			parentRecord: null,
			indexAtLevel: null,
		};
	}
	generateLoadingRecordArray(numberToGenerate){
		const loadingItems = [];
		loadingItems.push(GRID_HEADER_ROW);
		for(let count = 0; count < numberToGenerate; count++){
			loadingItems.push(this.generateLoadingRecordItem(count));
		}
		return loadingItems;
	}
	getRecordToDetailMap(recordArray, nestingFieldGUID, manualRecordSortOrder){
		const recordToParentRecordMap = new WeakMap(); // Not all records need to be keys, only those with parents
		const recordToSortIndexMap = new WeakMap();
		const parentToChildrenArrayMap = new Map();  //Can't be weak, because null must be able to be a key
		const recordGUIDtoRecordObject = {};
		let record, recordGUID, recordIndex, parentRecordGUID, parentRecord, recordDepth, parentRecordDepth;
				
		//Two for loops is faster than calling getParent inside another
		// Set up recordGuidToRecordObject
		for(recordIndex = 0; recordIndex < recordArray.length; recordIndex++){
			record = recordArray[recordIndex];
			recordGUID = record.$internals.metaProperties.meta.guid;
			recordGUIDtoRecordObject[recordGUID] = record;
		}

		// Set up recordToParentRecord, parentToChildrenArray maps
		for (recordIndex = 0; recordIndex < recordArray.length; recordIndex++) {
			record = recordArray[recordIndex];
			parentRecord = null; // Very important!  How root level nodes get shown
			if (nestingFieldGUID && record.fieldValues[nestingFieldGUID] && record.fieldValues[nestingFieldGUID].value) {
				parentRecordGUID = record.fieldValues[nestingFieldGUID].value;
				parentRecord = recordGUIDtoRecordObject[parentRecordGUID];
				if (parentRecord) {
					recordToParentRecordMap.set(record, parentRecord);
				} else {
					// parent record is no longer in the workbook, put it on the root
					parentRecord = null;
				}
			}
			if (!parentToChildrenArrayMap.has(parentRecord)) {
				parentToChildrenArrayMap.set(parentRecord, [record]);
			} else {
				parentToChildrenArrayMap.get(parentRecord).push(record)
			}
		}
		const recordDepthLevelByRecordMap = new Map();
		let hasInfiniteCycle = false;
		for(recordIndex = 0; recordIndex < recordArray.length; recordIndex++){
			record = recordArray[recordIndex];
			recordDepth = undefined;

			//A previous step may have already calculated our depth, so we can skip, potentially
			if (!recordDepthLevelByRecordMap.has(record)) {
				parentRecord = recordToParentRecordMap.get(record);

				if (parentRecord === undefined) {
					//We have a root object, so it's depth 0
					recordDepth = 0;
					recordDepthLevelByRecordMap.set(record, recordDepth);
				} else {

					//We have a parent, so let's go up the chain and get depth as necessary
					let currentRecordNode = parentRecord;					
					let parentsEncountered = [parentRecord];
					let depthFoundAtHighestRecognizedParent = undefined;						
					let visitedItems = new Set();
					visitedItems.add(currentRecordNode);
					//Loop up until we have a found depth of some parent (or we hit the root)
					while(depthFoundAtHighestRecognizedParent === undefined){
						//Look to see if this new parent has a depth
						let foundDepthOfParent = recordDepthLevelByRecordMap.get(currentRecordNode);
						if(foundDepthOfParent === undefined){
							//No depth found for that parent, so keep going up and see what we find
							currentRecordNode = recordToParentRecordMap.get(currentRecordNode)
							if(currentRecordNode){
								//Looks like we have another parent -- we'll loop back around
								if (visitedItems.has(currentRecordNode)) {
									hasInfiniteCycle = true;
									depthFoundAtHighestRecognizedParent = 0; // ONLY SETTING THIS TO BREAK THE WHILE LOOP, BUT EVERYTHING FROM HERE ON IS BROKEN
								} else {
									visitedItems.add(currentRecordNode);
									parentsEncountered.push(currentRecordNode);		
								}						
							}
							else{
								//That record was a root, so we can wrap up -- do nothing
								depthFoundAtHighestRecognizedParent = 0;									
							}								
						}
						else{
							//We found a parent with a known depth -- we can simply use that
							depthFoundAtHighestRecognizedParent = foundDepthOfParent;								
						}
					}
					//Loop through all the parents we had to traverse along the way and assign their now-known depths
					for(let subDepth = 0; subDepth < parentsEncountered.length; subDepth++){
						const currentParentToAssignDepth = parentsEncountered[subDepth];
						const depthOfThisParent = (parentsEncountered.length - 1 - subDepth) + depthFoundAtHighestRecognizedParent;
						recordDepthLevelByRecordMap.set(currentParentToAssignDepth, depthOfThisParent);
					}

					//Ultimately, assign the depth of the record we started with
					recordDepth = parentsEncountered.length + depthFoundAtHighestRecognizedParent;
					recordDepthLevelByRecordMap.set(record, recordDepth);
				}
			}
		}

		// console.log("recordDepthLevelByRecordMap", recordDepthLevelByRecordMap);

		//Now that we have a map of record to depth, create a reverse reference -- from depth to array of records
		const recordArraysByDepthLevelArray = [];
		recordDepthLevelByRecordMap.forEach(function withRecordToDepthLevel(depthLevel, record){
			recordArraysByDepthLevelArray[depthLevel] = recordArraysByDepthLevelArray[depthLevel] || [];
			recordArraysByDepthLevelArray[depthLevel].push(record);
		});		

		// console.log('recordsByDepthLevel - v Yaro');
		// console.log(recordArraysByDepthLevelArray);

		// Set up recordToSortIndexMap
		for(let sortIndex = 0; sortIndex < manualRecordSortOrder.length; sortIndex++){
			record = recordGUIDtoRecordObject[manualRecordSortOrder[sortIndex]];
			if(record){
				recordToSortIndexMap.set(record, sortIndex);
			}
		}
		return {hasInfiniteCycle, recordToParentRecordMap, recordToSortIndexMap, parentToChildrenArrayMap, recordDepthLevelByRecordMap, recordArraysByDepthLevelArray};
	}
	getHierarchyDetails(sheetView){
		const sheetViewHierarchy = sheetView.properties.display && sheetView.properties.display.hierarchy;
		const sheetViewHierarchyRootLevel = (sheetViewHierarchy ? sheetViewHierarchy.rootLevel || 0 : 0);
		const sheetViewHierarchyDepth = (sheetViewHierarchy && sheetViewHierarchy.depth !== null ? sheetViewHierarchy.depth : Number.MAX_SAFE_INTEGER);

		return {sheetViewHierarchyRootLevel, sheetViewHierarchyDepth};
	}
	getChildrenOfRecord(parentRecord, arrayOfAllRecords, recordToParentRecordMap){
		const childrenArray = [];
		const updatedArrayOfRemainingRecords = [];

		for(let recordIndex = 0; recordIndex < arrayOfAllRecords.length; recordIndex++){
			const record = arrayOfAllRecords[recordIndex];
			let includeInChildren = (recordToParentRecordMap.get(record) || null) === parentRecord;
			if(includeInChildren){
				childrenArray.push(record);
			}
			else{
				updatedArrayOfRemainingRecords.push(record);
			}
		}

		return {
			childrenArray,
			updatedArrayOfRemainingRecords,
		};
	}
	establishNestingStructure(parentsNestedItem, parameters){
		/* A function intended to be called recursively.
			Goes through and establishes a nested structure of records, children
			It also adds the "new record row" item and can accomodate expansion to add other mid-row items

		*/


		const grdSelf = this;	

		const {
			depth,
			sheetView,
			nestingDisclosureArray,
			nestingFieldGUID,
			userHasPermissionToAddNewRecords,			
			recordToParentRecordMap,
			parentToChildrenArrayMap,
			sheetViewHierarchyRootLevel, 
			sheetViewHierarchyDepth,
			disclosureTriangleShowsRecordChildren,
			recordArraysByDepthLevelArray,
		} = parameters;

		//Could be negative if nesting starts showing below root level
		const depthFromDisplayedRoot = depth - sheetViewHierarchyRootLevel;

		const parentRecord = parentsNestedItem && parentsNestedItem.ownDisplayItem && parentsNestedItem.ownDisplayItem.record;


		let childrenArray;
		//If we happen to be at the highest shown level (and it's not zero), then we set all the records at this level as the children
		if (sheetViewHierarchyRootLevel > 0 && sheetViewHierarchyRootLevel === depth ) {
			childrenArray = recordArraysByDepthLevelArray[depth] || [];
		}
		else{
			//Otherwise, just fil the children array using this record's children
			childrenArray = parentToChildrenArrayMap.get(parentRecord) || [];
		}
		
		parentsNestedItem.hasChildrenVisibleAccordingToNestingLevelsShown = !!childrenArray.length;

		//Currently unused -- self-explanatory var name
		const nextDepthLevelIsAboveRootDepth = depth + 1 <= sheetViewHierarchyRootLevel;

		//The deepest level we will show
		const terminalDepthLevel = sheetViewHierarchyRootLevel + sheetViewHierarchyDepth;

		//How many levels above the deepest depth are we right now?
		const distanceAboveTerminalDepth = terminalDepthLevel - depth;

		//Decide whether to inspect next level if it's not going to go too deep
		const shouldInspectNextLevelForChildren = depth + 1 <= terminalDepthLevel;

		//An object we pass around to help with recursive calls.
		const baseParametersForRecursiveChildCall = Object.assign({}, parameters, {
			depth: depth + 1,			
		});

		//If we're at least above the visible zone and we, ourselves, are a record
		const childrenRecordsHaveParent = depthFromDisplayedRoot >= 0 && !!parentRecord;

		for(let childIndex = 0; childIndex < childrenArray.length; childIndex++){
			const childRecord = childrenArray[childIndex];

			const recordGUID = childRecord.$internals.metaProperties.meta.guid;

			const childsDisclosureTriangleShowsRecordChildren = nestingDisclosureArray && nestingDisclosureArray.indexOf(recordGUID) >= 0;

			const recordDetails = new RecordDisplayDetails({
				record: childRecord,
				parentRecord,
			},{
				key: recordGUID,
				depth,
				depthFromDisplayedRoot,
				distanceAboveTerminalDepth,
				childsDisclosureTriangleShowsRecordChildren,
				parentsDisclosureTriangleShowsRecordChildren: disclosureTriangleShowsRecordChildren,
				recordHasParents: depthFromDisplayedRoot > 0 && childrenRecordsHaveParent,
			});

			const childNestedItem = new NestedItem(recordDetails, parentsNestedItem);

			parentsNestedItem.addChild(childNestedItem);

			const shouldBuildNextDepthLevelUnderRecord = shouldInspectNextLevelForChildren;

			if(shouldBuildNextDepthLevelUnderRecord){

				const parametersForChildCall = Object.assign({}, baseParametersForRecursiveChildCall, {
					disclosureTriangleShowsRecordChildren: childsDisclosureTriangleShowsRecordChildren,
				});

				grdSelf.establishNestingStructure(childNestedItem, parametersForChildCall);
			}
		}

		const shouldShowNewRecordAdd = sheetViewHierarchyRootLevel === 0 && depth === 0 && userHasPermissionToAddNewRecords;

		if(shouldShowNewRecordAdd){

			let key;
			if(parentRecord){
				key = `New-record-row-under-${parentRecord.$internals.metaProperties.meta.guid}`;
			}
			else{
				key = 'New-record-row-under-root';
			}

			const recordAddRow = new RecordAddRow({
				parentRecord,
			}, {
				key,
				depth,
				depthFromDisplayedRoot,
				distanceAboveTerminalDepth,
				parentsDisclosureTriangleShowsRecordChildren: true,
				recordHasParents: childrenRecordsHaveParent,
			});

			parentsNestedItem.addChild(new NestedItem(recordAddRow, parentsNestedItem));
		}
	}
	getGridHelperDetails({workbookHasRecords, hasRecordsDisplayed, userHasPermissionToAddNewRecords, rootLevelShown, filtersAreApplied}){		

		if(!workbookHasRecords){
			if(userHasPermissionToAddNewRecords){
				if(rootLevelShown){
					/* 
						There are no records in this workbook
						The user can add them 
						And they're at the root level to add them
					*/
					return {
						gridHelperDetails:{
							helpType: 'promptToAddFirstRecord',							
						},
						heightPX: 72 + 24 + 6 + 20 + 60,
					};

				}
				else{
					/* 
						There are no records in this workbook
						The user can add them 
						But they're NOT at the root level to add them
					*/
					return {
						gridHelperDetails:{
							helpType: 'promptToAddRecordAfterUpdatingLevels',							
						},
						heightPX: 72 + 24 + 6 + 20 + 60,
					};
				}
			}
			else{
				/* 
					There are no records in this workbook
					The user does not have permission to add them 					
				*/
				return {
					gridHelperDetails:{
						helpType: 'promptToAddRecordByRequestingPermission',						
					},
					heightPX: 72 + 24 + 6 + 20 + 60,
				};
			}
		}
		else{
			if(hasRecordsDisplayed){
				if(userHasPermissionToAddNewRecords){
					if(rootLevelShown){
						/* 
							There are records in the workbook
							And there are records displayed
							The user has permission to add them 					
							And they are at the root so they can add them
						*/
						return null;
					}
					else{
						/* 
							There are records in the workbook
							And there are records displayed
							The user has permission to add them 					
							But they can only add them from the left menu
						*/
						return {
							gridHelperDetails:{
								helpType: 'promptToAddSubItemsOnly',								
							}
						};
					}
				}
				else{
					/* 
						There are records in the workbook
						And there are records displayed
						The user does not have permission to add records						
					*/
					return null;
				}
			}
			else{
				if(filtersAreApplied){
					/* 
						There are records in the workbook
						But none of the records are displayed
						There are filters applied, which could be preventing them from seeing their records
					*/
					return {
						gridHelperDetails:{
							helpType: 'promptToRelaxFilters',								
						}
					};
				}
				else{
					/* 
						There are records in the workbook
						But none of the records are displayed
						No filters are applied, so something else is causing them not to show
					*/
					return {
						gridHelperDetails:{
							helpType: 'promptToResetNestingLevels',								
						}
					};
				}
			}			
		}
	}
	addGridHelperRow({flattenedDisplayArray, allActiveRecordsInDataStore, userHasPermissionToAddNewRecords, sheetViewHierarchyRootLevel, activeLabels}){
		const grdSelf = this;
		//Count of displayed records
		//Count of items in the workbook
		//Has permission to add
		//Showing root level (with add capability)
		//Filters are applied

		const hasRecordsDisplayed = !!flattenedDisplayArray.find(function isRecord(row){
			return row.type === 'existingRecord';
		});

		const workbookHasRecords = allActiveRecordsInDataStore.length > 0;

		const rootLevelShown = sheetViewHierarchyRootLevel === 0;				

		const filtersAreApplied = !!Object.values(activeLabels).find(function isLabel(labelDetails){
			return labelDetails.filtering && labelDetails.filtering.activeFilteredValues && labelDetails.filtering.activeFilteredValues.length > 0;
		});

		const gridHelperDetails = grdSelf.getGridHelperDetails({workbookHasRecords, hasRecordsDisplayed, userHasPermissionToAddNewRecords, rootLevelShown, filtersAreApplied});

		if(gridHelperDetails){
			flattenedDisplayArray.push(Object.assign({}, GRID_HELPER_ROW, gridHelperDetails));
		}

	}
	applyNumbering(arrayOfNestedItems){

		const orderArray = [];
		let lastDepth = -1;
		let countOfRecords = 0;
		for(let rowIndex = 0; rowIndex < arrayOfNestedItems.length; rowIndex++){
			// console.log(`At array index ${rowIndex}`);
			const displayItem = arrayOfNestedItems[rowIndex];
			displayItem.flatArrayIndex = rowIndex;			

			if(displayItem.type === 'existingRecord'){

				displayItem.flatArrayRecordIndex = countOfRecords;
				countOfRecords++;
				
				// console.log(`This is a record, so proceeding`);				

				const currentDepth = displayItem.depth;
				
				//Indented out again -- reset counter to 
				if(currentDepth < lastDepth){
					// console.log(`Outdenting -- just incrementing the previous number`);
					for(let popCount = 0; popCount < lastDepth - currentDepth; popCount++){
						orderArray.pop();
					}					
					orderArray[orderArray.length - 1] += 1;
				}

				else if(currentDepth > lastDepth){					
					// console.log(`Indenting -- adding zero to end`);
					orderArray.push(0)
				}

				//Same depth as before -- just increment
				else{					
					// console.log(`Same depth -- Incrementing last number`);
					orderArray[orderArray.length - 1] += 1;
				}

				//Make a copy
				displayItem.orderArray = orderArray.slice();
				// console.log(`Assigned value: `, displayItem.orderArray);

				lastDepth = currentDepth;

			}
		}
	}
	getFlatRecordDisplayArray({dataStore, sheetView, systemState, ConnectedApps, manualRecordSortOrder, hideUntilLoadCompletes, isLoadingRecords}){
		const grdSelf = this;

		// const startTime = performance.now();		

		if(hideUntilLoadCompletes || isLoadingRecords){
			return {
				hadInfiniteCycleBeforeRecalculating: false,
				flattenedDisplayArray: grdSelf.generateLoadingRecordArray(3)
			};
		}

		const allActiveRecordsInDataStore = dataStore.getRecords();

		let nestingFieldGUID = dataStore.getChildToParentNestingFieldGUID();
		
		let recordToDetailMapReturn = grdSelf.getRecordToDetailMap(allActiveRecordsInDataStore, nestingFieldGUID, manualRecordSortOrder)
		const hadInfiniteCycleBeforeRecalculating = recordToDetailMapReturn.hasInfiniteCycle;
		if (hadInfiniteCycleBeforeRecalculating) { // We have an infinite parent loop with field nesting, so recalculate everything without the nestingFieldGUID
			nestingFieldGUID = null;
			recordToDetailMapReturn = grdSelf.getRecordToDetailMap(allActiveRecordsInDataStore, nestingFieldGUID, manualRecordSortOrder);
		}
		const {
			hasInfiniteCycle,
			recordToParentRecordMap,
			recordToSortIndexMap,
			parentToChildrenArrayMap,
			recordDepthLevelByRecordMap, 
			recordArraysByDepthLevelArray
		} = recordToDetailMapReturn;
		const {sheetViewHierarchyRootLevel, sheetViewHierarchyDepth} = grdSelf.getHierarchyDetails(sheetView);
		const nestingDisclosureArray = sheetView.getNestingDisclosureArray();

		const rootNestedItem = new NestedItem(null, null);

		const userHasPermissionToAddNewRecords = dataStore.hasPermission('record_addNew');

		const activeLabels = sheetView.properties.labels && sheetView.properties.labels.activeLabels;
		grdSelf.establishNestingStructure(rootNestedItem, {
			depth: sheetViewHierarchyRootLevel,
			sheetView,
			nestingDisclosureArray,
			nestingFieldGUID,
			userHasPermissionToAddNewRecords,
			disclosureTriangleShowsRecordChildren: true,			
			recordToParentRecordMap,
			parentToChildrenArrayMap,
			sheetViewHierarchyRootLevel, 
			sheetViewHierarchyDepth,
			recordArraysByDepthLevelArray,
		});

		const recordsVisibleInView = {};

		rootNestedItem.setAndReturnVisibility({
			depth: sheetViewHierarchyRootLevel,
			sheetView,
			activeLabels,			
			sheetViewHierarchyRootLevel, 
			sheetViewHierarchyDepth,
			systemState, 
			ConnectedApps,
		}, recordsVisibleInView);

		rootNestedItem.recursivelyRemoveInvisibleItems();

		rootNestedItem.recursivelySortItems({
			recordToSortIndexMap,
		});

		//Establish stats and nesting
		rootNestedItem.addRenderingAnnotations({
			depth: sheetViewHierarchyRootLevel,
			sheetViewHierarchyRootLevel,
			nestingGlobalStats:{
				maximumDepth: 0,
			},
			orderArray: [],
		});

		//Flatten array
		const flattenedDisplayArray = [GRID_HEADER_ROW];
		rootNestedItem.addToFlatArray(flattenedDisplayArray);
		grdSelf.addGridHelperRow({
			flattenedDisplayArray,
			allActiveRecordsInDataStore,
			userHasPermissionToAddNewRecords,
			sheetViewHierarchyRootLevel,
			activeLabels,
		})

		grdSelf.applyNumbering(flattenedDisplayArray);		

		// const duration = performance.now() - startTime;
		// console.log(flattenedDisplayArray);

		return { hadInfiniteCycleBeforeRecalculating, flattenedDisplayArray, recordsVisibleInView };
	}
}

export default new GridRecordDisplay();